export { APPLICATION_FILE_MANAGER } from "./FileManager";
export { APPLICATION_MINESWEEPER } from "./Minesweeper";
export { APPLICATION_PDF_VIEWER } from "./PdfViewer";
export { APPLICATION_TEAPOT } from "./Teapot";
export { APPLICATION_TEXT_EDITOR } from "./TextEditor";
